import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsRetrieveUserBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Retrieve user</div>
          <div className="text">
            Retrieves the details of an existing user. You must specify exactly one of: their Canny
            id, their id in your application, or their email. These fields are all unique per user.
          </div>
          <div className="text">
            You can only retrieve them based on their id in your application if the user was
            authenticated via single sign-on or created via API.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The user's email.",
                heading: 'email',
                subheading: 'string (optional)',
              },
              {
                description: "The user's unique identifier from Canny.",
                heading: 'id',
                subheading: 'string (optional)',
              },
              {
                description: "The user's unique identifier in your application.",
                heading: 'userID',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns a user object, if a valid identifier was supplied.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/users/retrieve</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/users/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d id=553c3ef8b8cdcd1501ba123a`}
          />
          <APIDocsCurl
            path="https://canny.io/api/v1/users/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d userID=1234`}
          />
          <APIDocsCurl
            path="https://canny.io/api/v1/users/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d email="test@test.test"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba123a",
  "alias": "Green Fish",
  "avatarURL": "https://canny.io/images/a3db0133d1e7d9122832b67b2c4caaaa.jpg",
  "created": "${this.createdAt.toISOString()}",
  "customFields": {
    "field1": "value1",
    "field2": "value2"
  },
  "email": "test@test.test",
  "isAdmin": false,
  "lastActivity": "${this.createdAt.toISOString()}",
  "name": "Sally Doe",
  "url": "https://your-company.canny.io/admin/users/sally-doe",
  "userID": "1234"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
